<template>
  <b-card>
    <h1>{{ $t('pages.payment.title') }}</h1>
    <iframe
      :src="`https://se.servicestart.com/account/payment/ccd.do?ui=${userId}`"
      width="100%"
      style="border: 0; width: 100%; height: 600px; overflow: hidden;"
    />
  </b-card>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t('pages.payment.title'),
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userId() {
      return this.$route.params['userId'] || this.user?.userId;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store
      .dispatch('getUser')
      .then(() => {
        next();
      })
      .catch(() => {
        next();
      });
  },
};
</script>
